var _defs, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6054dec6-a1c2-4a64-a8d8-6ee0df86f9f5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-3c767938-5f64-4675-a123-994bcd66e6de {\n        fill: #f2f2f2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-3c767938-5f64-4675-a123-994bcd66e6de",
    cx: 16,
    cy: 16,
    r: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-3c767938-5f64-4675-a123-994bcd66e6de",
    cx: 16,
    cy: 21.25,
    r: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-3c767938-5f64-4675-a123-994bcd66e6de",
    cx: 16,
    cy: 10.75,
    r: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDown);
export default __webpack_public_path__ + "static/media/MenuDown.3e7d34d3f3a70a62dd6225fd4b38ffdd.svg";
export { ForwardRef as ReactComponent };